import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

import { AnalyticsService } from './analytics.service';
import { UtilService } from 'src/app/core/utilities/util.service';
import { TitleConfigService } from '../landing-page/title-config.service';
import { LandingPageService } from '../landing-page/landing-page.service';

export interface PageTitleConfig {
  route: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsRouterService {
  constructor(
    private router: Router,
    private analytics: AnalyticsService,
    private utilService: UtilService,
    private pageTitleService: TitleConfigService,
    private landingPageService: LandingPageService,
  ) {
    this.trackInitialPage();
  }

  private trackInitialPage(): void {
    this.landingPageService.$landed.subscribe((event) => {
      const userProfile = this.utilService.getUserProfile();

      if (
        event.urlAfterRedirects &&
        this.isExcluded(event.urlAfterRedirects) == false
      ) {
        this.analytics.trackPageView({
          pageName: this.pageTitleService.getCurrentTitle(),
          userId: userProfile?.registeredUserNumber,
        });
      }
    });
  }

  private isExcluded(fullUrl: string): boolean {
    const exclude = ['/services'];

    const excludedFound = exclude.filter((ex) => fullUrl.indexOf(ex) >= 0);

    return excludedFound.length > 0;
  }
}
